//Tooltip functions
export default class Tooltip {
    body;
    toolTips;
    toolTipContent;
    constructor() {
        this.body = document.querySelector('body');
        this.toolTips = this.body.querySelectorAll('.js-tooltip');
        if (!(this.toolTips.length > 0))
            return;
        this.toolTips.forEach((tooltip) => tooltip.addEventListener('click', this.ToolTipFunc));
    }
    ToolTipFunc(event) {
        let element = event.target;
        element.nextElementSibling.classList.toggle('open');
    }
}
